
import { StopDrawingOriginalStop } from '@/models/main';
import { JobDetailedData, JobDetailedStop } from '@/models/jobDetailed';
import { Component, Prop, Vue } from 'vue-property-decorator';
import StopCompleteDialog from '@/components/jobDetailed/StopCompleteDialog/StopCompleteDialog.vue';
import StopCompleteLastStopDialog from '@/components/jobDetailed/StopCompleteDialog/StopCompleteLastStopDialog.vue';
import { notifyNetworkError } from '@/helpers/notifiers';

@Component({
  components: {
    StopCompleteDialog,
    StopCompleteLastStopDialog,
  },
})
export default class StopDrawing extends Vue {
  @Prop({ type: Array, default: () => [] }) public readonly stops!: JobDetailedStop[];
  @Prop(String) private completed_at: string;
  @Prop(Object) public original_stop: StopDrawingOriginalStop;
  @Prop(Object) public job!: JobDetailedData;
  @Prop({ type: Boolean, default: true }) public editable: boolean;
  @Prop({ type: Boolean, default: true }) public showNotes: boolean;

  public completeJobData = {
    isOpen: false,
    action: '',
    stop: -1,
  };

  public stopComplete(idx: number, action: 'arrived' | 'completed' | 'departed'): void {
    const isAllocated = this.job.allocation_state === 'allocated';
    const isLastStop = idx === this.stops.length;
    const isCancellable = isLastStop && action === 'completed';

    if (!isAllocated && !isCancellable) {
      notifyNetworkError({ text: "Can't complete stops if the job is not allocated" });
      return;
    }

    if (this.editable) {
      this.completeJobData = {
        isOpen: true,
        action: action,
        stop: idx,
      };
    }
  }

  public get position() {
    switch (true) {
      case !!this.stops[2]?.departed_at || (!!this.completed_at && !!this.stops[2]):
        return 6;
      case !!this.stops[2]?.arrived_at:
        return 5;
      case !!this.stops[1].departed_at || (!!this.completed_at && !this.stops[2]):
        return 4;
      case !!this.stops[1].arrived_at:
        return 3;
      case !!this.stops[0].departed_at:
        return 2;
      case !!this.stops[0].arrived_at:
        return 1;
      case !this.stops[0].arrived_at:
        return 0;
      default:
        return 0;
    }
  }
}
